<template>
  <div class="vgnes-outdoor-monitor" @click="registerInteraction" @touchstart="registerInteraction">
    <main class="main-panel">
      <section class="status-section">
        <div class="identity-column">
          <div class="vgnes-logo" aria-label="Verwaltungsgemeinschaft Bad Neustadt a. d. Saale">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="184" height="55" viewBox="0 0 184 55">
              <defs>
                <clipPath id="clip-Web_1920_1">
                  <rect width="184" height="55"/>
                </clipPath>
              </defs>
              <g id="Web_1920_1" data-name="Web 1920 – 1" clip-path="url(#clip-Web_1920_1)">
                <g id="Gruppe_1" data-name="Gruppe 1" transform="translate(-227.969 -78.162)">
                  <g id="Gruppe_20" data-name="Gruppe 20" transform="translate(-170.031 5.162)">
                    <path id="Pfad_22" data-name="Pfad 22" d="M0,52.809V.04H7.392V34.715L41.75,0H52.27Z" transform="translate(399 74)" fill="#008002"/>
                    <path id="Pfad_23" data-name="Pfad 23" d="M272.93,53.147h.329v6.306h7.4V40.421H261.632v7.437l6.287.028-.809.89L265.9,49.991a8.56,8.56,0,0,1-3.965,2.185,5.669,5.669,0,0,1-6.555-5.907,7.485,7.485,0,0,1,2.1-4.936h0L280.7,17.9V7.2L254.243,33.944l-2.589,2.614h0c-3.237,3.48-3.68,5.7-3.722,9.63a13.265,13.265,0,0,0,13.514,13.271c5.179,0,6.8-1.942,11.491-6.312Z" transform="translate(172.004 67.383)" fill="#125481"/>
                  </g>
                  <path id="Pfad_33" data-name="Pfad 33" d="M4.935,14.86,1.5,5.515H.36L4.335,16h1.2L9.51,5.515H8.4ZM16.56,5.5H11.085V16H16.56v-.87H12.135V11.155H16.11v-.87H12.135V6.37H16.56Zm7.71,3.06c0,1.275-.765,2.2-2.475,2.2H19.68V6.4h2.1C23.55,6.4,24.27,7.24,24.27,8.56ZM18.63,5.515V16h1.05V11.62h1.935L24.21,16h1.26l-2.7-4.455A2.893,2.893,0,0,0,25.35,8.56c0-1.725-1.14-3.045-3.57-3.045Zm10.9,10.5L30.675,16l2.7-8.94L36.015,16h1.17l2.97-10.485H39.03L36.615,14.71l-2.61-9.195h-1.17L30.15,14.71l-2.4-9.195H26.625ZM48.75,16h1.11L46.05,5.65H44.865L41.04,16h1.11l.915-2.49h4.77Zm-1.23-3.36H43.38l2.07-5.67Zm4.02-7.125V16h4.815v-.855H52.59V5.515Zm5.565.87H60.03V16h1.05V6.385h2.91v-.87H57.1ZM65.61,12.1c0,2.775,1.68,4,3.81,4s3.81-1.23,3.81-4V5.515H72.18v6.6c0,2.175-1.11,3.06-2.745,3.06s-2.775-.885-2.775-3.06v-6.6H65.61ZM82.425,5.515v8.8l-5.805-8.8H75.57V16h1.05V7.18L82.425,16h1.05V5.515Zm8.145-.12a5.122,5.122,0,0,0-5.19,5.355A5.113,5.113,0,0,0,90.57,16.1a5.037,5.037,0,0,0,5.1-4.9v-.765H90.15v.855h4.41a3.874,3.874,0,0,1-3.99,3.87,4.071,4.071,0,0,1-4.11-4.41,4.058,4.058,0,0,1,4.11-4.4,3.693,3.693,0,0,1,3.54,2.22h1.23A4.862,4.862,0,0,0,90.57,5.395Zm13.575,7.845c0-3.9-5.76-2.04-5.76-5.07a1.974,1.974,0,0,1,2.25-1.875,2.144,2.144,0,0,1,2.28,1.65h1.14c-.18-1.44-1.38-2.55-3.375-2.55-2.025,0-3.36,1.185-3.36,2.805,0,3.945,5.76,1.995,5.76,5.085,0,1.08-.855,1.935-2.31,1.935a2.179,2.179,0,0,1-2.43-1.92H97.23c.06,1.6,1.44,2.8,3.54,2.8C102.99,16.1,104.145,14.665,104.145,13.24Zm1.275-2.355h5.835V10H105.42ZM5.91,19.4A5.122,5.122,0,0,0,.72,24.75,5.113,5.113,0,0,0,5.91,30.1a5.037,5.037,0,0,0,5.1-4.9v-.765H5.49v.855H9.9a3.874,3.874,0,0,1-3.99,3.87A4.071,4.071,0,0,1,1.8,24.75a4.058,4.058,0,0,1,4.11-4.4,3.693,3.693,0,0,1,3.54,2.22h1.23A4.862,4.862,0,0,0,5.91,19.4Zm12.495.1H12.93V30H18.4v-.87H13.98V25.155h3.975v-.87H13.98V20.37H18.4ZM20.475,30h1.05V21.765L25.215,30h.765l3.69-8.265V30h1.05V19.65H29.6L25.59,28.62l-4.005-8.97h-1.11ZM38.58,19.5H33.1V30H38.58v-.87H34.155V25.155H38.13v-.87H34.155V20.37H38.58ZM40.65,30H41.7V19.515H40.65ZM50.94,19.515V28.32l-5.805-8.805h-1.05V30h1.05V21.18L50.94,30h1.05V19.515Zm9.99,7.725c0-3.9-5.76-2.04-5.76-5.07A1.974,1.974,0,0,1,57.42,20.3a2.144,2.144,0,0,1,2.28,1.65h1.14c-.18-1.44-1.38-2.55-3.375-2.55-2.025,0-3.36,1.185-3.36,2.805,0,3.945,5.76,1.995,5.76,5.085,0,1.08-.855,1.935-2.31,1.935a2.179,2.179,0,0,1-2.43-1.92h-1.11c.06,1.605,1.44,2.805,3.54,2.805C59.775,30.1,60.93,28.665,60.93,27.24Zm1.545-2.49a5.07,5.07,0,0,0,5.13,5.34,4.856,4.856,0,0,0,4.83-3.15h-1.23a3.667,3.667,0,0,1-3.6,2.235c-2.3,0-4.05-1.695-4.05-4.425s1.755-4.44,4.05-4.44a3.649,3.649,0,0,1,3.6,2.265h1.23a4.842,4.842,0,0,0-4.83-3.18A5.083,5.083,0,0,0,62.475,24.75ZM81.255,30h1.05V19.515h-1.05v4.71H75.57v-4.71H74.52V30h1.05V25.1h5.685Zm10.44,0h1.11l-3.81-10.35H87.81L83.985,30h1.11l.915-2.49h4.77Zm-1.23-3.36h-4.14l2.07-5.67ZM94.485,30h1.05V25.17h3.9V24.3h-3.9V20.385h4.62v-.87h-5.67Zm6.645-9.615h2.925V30h1.05V20.385h2.91v-.87H101.13Z" transform="translate(297 74)" fill="#656565"/>
                  <path id="Pfad_34" data-name="Pfad 34" d="M7.3,10.6a2.449,2.449,0,0,1,1.47.907,2.577,2.577,0,0,1,.555,1.628,2.587,2.587,0,0,1-.922,2.092A3.892,3.892,0,0,1,5.835,16H.93V5.47H5.67A3.886,3.886,0,0,1,8.182,6.2a2.431,2.431,0,0,1,.908,2A2.41,2.41,0,0,1,8.6,9.745,2.521,2.521,0,0,1,7.3,10.6Zm-3.81-.87h1.68a1.487,1.487,0,0,0,.967-.278,1,1,0,0,0,.338-.817,1.019,1.019,0,0,0-.338-.825,1.46,1.46,0,0,0-.967-.285H3.495Zm1.89,4.2a1.521,1.521,0,0,0,1-.293,1.038,1.038,0,0,0,.352-.847,1.085,1.085,0,0,0-.368-.87A1.506,1.506,0,0,0,5.355,11.6H3.495V13.93Zm11.985.21H13.44L12.81,16H10.125l3.81-10.53h2.97L20.715,16H18Zm-.66-1.98L15.405,8.305l-1.29,3.855Zm9.1-6.69a6.125,6.125,0,0,1,2.91.66,4.715,4.715,0,0,1,1.927,1.852,5.443,5.443,0,0,1,.683,2.752,5.454,5.454,0,0,1-.683,2.745,4.69,4.69,0,0,1-1.935,1.86,6.136,6.136,0,0,1-2.9.66H21.87V5.47Zm-.165,8.31a3.1,3.1,0,0,0,2.265-.8,3.01,3.01,0,0,0,.81-2.25,3.062,3.062,0,0,0-.81-2.265,3.062,3.062,0,0,0-2.265-.81H24.435v6.12ZM45.375,16H42.81L38.52,9.505V16H35.955V5.47H38.52L42.81,12V5.47h2.565ZM49.8,7.525v2.13h3.435v1.98H49.8v2.31h3.885V16h-6.45V5.47h6.45V7.525ZM57.87,5.47v6.3a2.085,2.085,0,0,0,.465,1.455,1.754,1.754,0,0,0,1.365.51,1.8,1.8,0,0,0,1.38-.51,2.043,2.043,0,0,0,.48-1.455V5.47h2.565v6.285a4.468,4.468,0,0,1-.6,2.385,3.842,3.842,0,0,1-1.612,1.47,5.071,5.071,0,0,1-2.257.495,4.945,4.945,0,0,1-2.228-.487,3.634,3.634,0,0,1-1.552-1.47,4.7,4.7,0,0,1-.57-2.392V5.47ZM69.735,16.1a5.417,5.417,0,0,1-2.07-.375A3.374,3.374,0,0,1,66.2,14.62a3.033,3.033,0,0,1-.577-1.77h2.73a1.325,1.325,0,0,0,.4.892,1.3,1.3,0,0,0,.9.307,1.408,1.408,0,0,0,.9-.262.878.878,0,0,0,.33-.727.861.861,0,0,0-.262-.645,2.118,2.118,0,0,0-.645-.42A10.375,10.375,0,0,0,68.9,11.62a11.841,11.841,0,0,1-1.665-.63,3.076,3.076,0,0,1-1.11-.93,2.591,2.591,0,0,1-.465-1.6,2.76,2.76,0,0,1,1.065-2.3A4.376,4.376,0,0,1,69.5,5.32a4.427,4.427,0,0,1,2.805.833A2.98,2.98,0,0,1,73.44,8.47H70.665a1.085,1.085,0,0,0-.375-.8,1.321,1.321,0,0,0-.885-.293,1.1,1.1,0,0,0-.75.248.893.893,0,0,0-.285.713.883.883,0,0,0,.48.795,7.868,7.868,0,0,0,1.5.615,13.872,13.872,0,0,1,1.657.66,3.155,3.155,0,0,1,1.1.915,2.449,2.449,0,0,1,.465,1.545,3.032,3.032,0,0,1-.458,1.635,3.2,3.2,0,0,1-1.327,1.17A4.544,4.544,0,0,1,69.735,16.1ZM82.725,5.47V7.525h-2.79V16H77.37V7.525H74.58V5.47Zm7.845,8.67H86.64L86.01,16H83.325l3.81-10.53H90.1L93.915,16H91.2Zm-.66-1.98L88.6,8.305l-1.29,3.855Zm9.105-6.69a6.125,6.125,0,0,1,2.91.66,4.715,4.715,0,0,1,1.927,1.852,5.443,5.443,0,0,1,.683,2.752,5.454,5.454,0,0,1-.683,2.745,4.69,4.69,0,0,1-1.935,1.86,6.136,6.136,0,0,1-2.9.66H95.07V5.47Zm-.165,8.31a3.1,3.1,0,0,0,2.265-.8,3.01,3.01,0,0,0,.81-2.25,3.062,3.062,0,0,0-.81-2.265,3.062,3.062,0,0,0-2.265-.81H97.635v6.12Zm14.7-8.31V7.525h-2.79V16h-2.565V7.525H105.4V5.47ZM7.485,28.14H3.555L2.925,30H.24L4.05,19.47H7.02L10.83,30H8.115Zm-.66-1.98L5.52,22.305,4.23,26.16Zm6.36,3.96a1.555,1.555,0,0,1-1.1-.4,1.288,1.288,0,0,1-.427-.983,1.328,1.328,0,0,1,.427-1,1.538,1.538,0,0,1,1.1-.405,1.518,1.518,0,0,1,1.087.405,1.328,1.328,0,0,1,.428,1,1.288,1.288,0,0,1-.428.983A1.534,1.534,0,0,1,13.185,30.12ZM23.34,19.47a6.125,6.125,0,0,1,2.91.66,4.715,4.715,0,0,1,1.927,1.852,5.876,5.876,0,0,1,0,5.5,4.69,4.69,0,0,1-1.935,1.86,6.136,6.136,0,0,1-2.9.66H19.4V19.47Zm-.165,8.31a3.1,3.1,0,0,0,2.265-.8,3.01,3.01,0,0,0,.81-2.25,2.812,2.812,0,0,0-3.075-3.075H21.96v6.12ZM31.5,30.12a1.555,1.555,0,0,1-1.1-.4,1.288,1.288,0,0,1-.427-.983,1.328,1.328,0,0,1,.427-1,1.538,1.538,0,0,1,1.1-.405,1.518,1.518,0,0,1,1.088.405,1.328,1.328,0,0,1,.427,1,1.288,1.288,0,0,1-.427.983A1.534,1.534,0,0,1,31.5,30.12ZM41.52,30.1a5.417,5.417,0,0,1-2.07-.375,3.374,3.374,0,0,1-1.462-1.11,3.033,3.033,0,0,1-.577-1.77h2.73a1.325,1.325,0,0,0,.4.892,1.3,1.3,0,0,0,.9.307,1.408,1.408,0,0,0,.9-.262.878.878,0,0,0,.33-.728.861.861,0,0,0-.263-.645,2.118,2.118,0,0,0-.645-.42,10.376,10.376,0,0,0-1.087-.375,11.841,11.841,0,0,1-1.665-.63,3.076,3.076,0,0,1-1.11-.93,2.591,2.591,0,0,1-.465-1.6,2.76,2.76,0,0,1,1.065-2.3,4.376,4.376,0,0,1,2.775-.833,4.427,4.427,0,0,1,2.805.833,2.98,2.98,0,0,1,1.14,2.318H42.45a1.085,1.085,0,0,0-.375-.8,1.321,1.321,0,0,0-.885-.292,1.1,1.1,0,0,0-.75.248.893.893,0,0,0-.285.712.883.883,0,0,0,.48.8,7.868,7.868,0,0,0,1.5.615,13.872,13.872,0,0,1,1.658.66,3.155,3.155,0,0,1,1.1.915,2.449,2.449,0,0,1,.465,1.545A3.032,3.032,0,0,1,44.9,28.5a3.2,3.2,0,0,1-1.327,1.17A4.544,4.544,0,0,1,41.52,30.1ZM53.49,28.14H49.56L48.93,30H46.245l3.81-10.53h2.97L56.835,30H54.12Zm-.66-1.98-1.305-3.855-1.29,3.855Zm11.715,1.98h-3.93L59.985,30H57.3l3.81-10.53h2.97L67.89,30H65.175Zm-.66-1.98L62.58,22.305,61.29,26.16Zm7.725,1.86h3.36V30H69.045V19.47H71.61Zm7.155-6.5v2.13H82.2v1.98H78.765v2.31H82.65V30H76.2V19.47h6.45v2.055Z" transform="translate(297 102)" fill="#656565"/>
                </g>
              </g>
            </svg>
          </div>
          <div class="date-time">
            <div class="current-time">{{ currentTime }} Uhr</div>
            <div class="current-date">{{ currentDate }}</div>
          </div>
        </div>

        <div class="hours-panel" :class="{ 'is-closing': displayClosingMode }">
          <div class="clock-watermark">
            <svg viewBox="680 70 170 170" aria-hidden="true">
              <path fill="none" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" stroke="rgb(96.078491%, 96.078491%, 96.078491%)" stroke-opacity="1" stroke-miterlimit="10" d="M 0.00073125 0.00016875 C 0.00073125 -39.335769 -31.889894 -71.226394 -71.225831 -71.226394 C -110.565675 -71.226394 -142.452394 -39.335769 -142.452394 0.00016875 C -142.452394 39.336106 -110.565675 71.226731 -71.225831 71.226731 C -31.889894 71.226731 0.00073125 39.336106 0.00073125 0.00016875 Z M 0.00073125 0.00016875 " transform="matrix(1, 0, 0, -1, 829.3313, 150.5197)"/>
              <path fill="none" stroke-width="10" stroke-linecap="round" stroke-linejoin="round" stroke="rgb(96.078491%, 96.078491%, 96.078491%)" stroke-opacity="1" stroke-miterlimit="10" d="M -0.00170625 0.000975 L -22.579831 23.243162 L -22.579831 66.411131 " transform="matrix(1, 0, 0, -1, 780.6853, 178.5791)"/>
            </svg>
          </div>
          <h1 class="hoursHeadline">{{ hoursHeadline }}</h1>
          <div class="hours-list">
            <div
                v-for="row in activeHoursRows"
                :key="row.key"
                class="hours-row"
                :class="{ 'is-today': (!displayClosingMode && row.weekdayIndex === todayIndex) }"
            >
              <span class="today-marker" v-if="(!displayClosingMode && row.weekdayIndex === todayIndex)">Heute</span>
              <span class="hours-day">{{ row.day }}</span>
              <span class="hours-value">{{ row.value }}</span>
            </div>
          </div>
          <div class="mode-indicator" v-if="hasClosingRows">
            <span :class="{ active: !displayClosingMode }"></span>
            <span :class="{ active: displayClosingMode }"></span>
          </div>
        </div>
      </section>

      <section class="contacts-section" @touchstart="startContactSwipe" @touchend="finishContactSwipe" @touchcancel="resetContactSwipe">
        <div class="contacts-heading">
          <h2>{{ contactHeadline }}</h2>
          <span>{{ contactSubline }}</span>
        </div>

        <transition name="contact-slide" mode="out-in">
          <div :key="contactPage" class="contacts-page">
            <div v-if="contactPage === 0" class="overview-page">
              <div class="overview-list">
                <article v-for="contact in overviewContacts" :key="contact.title" class="overview-card">
                  <h3>{{ contact.title }}</h3>
                  <p class="overview-phone">{{ contact.phone }}</p>
                  <p class="overview-email">{{ contact.email }}<span v-if="contactPin(contact)" class="contact-pin"><strong>#{{ contactPin(contact) }}</strong></span></p>
                  <div class="contact-pin-bg">
                    <svg id="uuid-5024c832-b4e2-454c-9e72-67be19947bb8" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.4 107.29">
                      <g style="opacity: .15;">
                        <path d="M25.45,30.57H5.34c-2.95,0-5.34-2.4-5.34-5.34V5.34C0,2.4,2.4,0,5.34,0h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM5.34,5c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34V5.34c0-.18-.16-.34-.34-.34H5.34Z" style="fill: #656565;"/>
                        <path d="M25.45,68.93H5.34c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM5.34,43.36c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34H5.34Z" style="fill: #656565;"/>
                        <path d="M25.45,107.29H5.34c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM5.34,81.72c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34H5.34Z" style="fill: #656565;"/>
                        <path d="M65.76,30.57h-20.11c-2.95,0-5.34-2.4-5.34-5.34V5.34c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM45.64,5c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34V5.34c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                        <path d="M65.76,68.93h-20.11c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM45.64,43.36c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                        <path d="M65.76,107.29h-20.11c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM45.64,81.72c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                        <path d="M106.06,30.57h-20.11c-2.95,0-5.34-2.4-5.34-5.34V5.34c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM85.95,5c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34V5.34c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                        <path d="M106.06,68.93h-20.11c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM85.95,43.36c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                        <path d="M106.06,107.29h-20.11c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM85.95,81.72c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                      </g>
                    </svg>
                  </div>
                </article>
              </div>
              <button class="next-hint" type="button" @click.stop="nextContactPage">
                <span>Zu den Ämtern / Ansprechpartnern</span>
                <span class="arrow">›</span>
              </button>
            </div>

            <div v-else class="directory-page">
              <article v-for="contact in visibleDirectoryContacts" :key="contact.name + contact.phone" class="contact-card">
                <div class="contact-text">
                  <h3>{{ contact.name }}<span v-if="contact.department"> | {{ contact.department }}</span></h3>
                  <p v-if="contact.description">{{ contact.description }}</p>
<!--                  <p v-if="contact.room">Zimmer: {{ contact.room }}</p>-->
                </div>
                <p class="contact-phone">
                    <span class="phone-icon" aria-hidden="true">
                      <svg viewBox="136 860 46 46">
                        <path fill="none" stroke-width="3.303" stroke-linecap="butt" stroke-linejoin="miter" stroke="currentColor" stroke-opacity="1" stroke-miterlimit="10" d="M 0.00166875 -0.0008875 L -1.424113 -1.848544 C -1.9163 -2.485262 -2.658488 -2.8837 -3.459269 -2.934481 C -5.267863 -3.051669 -9.150675 -2.582919 -14.424113 0.475675 C -21.982706 4.850675 -27.638956 11.909269 -30.178019 20.264738 C -31.904581 25.96005 -31.451456 29.737394 -30.94755 31.463956 C -30.720988 32.233488 -30.170206 32.870206 -29.439738 33.206144 L -27.32255 34.190519 C -26.435831 34.600675 -25.38505 34.288175 -24.865519 33.463956 L -19.564738 25.069425 C -18.990519 24.163175 -19.263956 22.963956 -20.170206 22.393644 L -22.525675 20.905363 C -22.814738 20.721769 -22.951456 20.374113 -22.857706 20.045988 C -22.826456 19.940519 -22.7913 19.819425 -22.752238 19.682706 C -21.220988 14.58505 -17.775675 10.27255 -13.142863 7.655363 C -13.021769 7.58505 -12.908488 7.526456 -12.810831 7.475675 C -12.51005 7.311613 -12.142863 7.3663 -11.900675 7.604581 L -9.931925 9.577238 C -9.174113 10.33505 -7.943644 10.33505 -7.185831 9.577238 L -0.1663 2.557706 C 0.525106 1.8663 0.595419 0.77255 0.00166875 -0.0008875 Z M 0.00166875 -0.0008875 " transform="matrix(1, 0, 0, -1, 171.4163, 898.9288)"/>
                      </svg>
                    </span>
                  <strong>{{ contact.phone }}</strong><span v-if="contactPin(contact)" class="contact-pin"><strong>#{{ contactPin(contact) }}</strong></span>
                </p>
<!--                <div class="contact-meta">
                  <strong>#{{ contactPin(contact) }}</strong>
                </div>-->
                <div v-if="contactPin(contact)" class="contact-pin-bg">
                  <svg id="uuid-5024c832-b4e2-454c-9e72-67be19947bb8" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.4 107.29">
                    <g style="opacity: .15;">
                      <path d="M25.45,30.57H5.34c-2.95,0-5.34-2.4-5.34-5.34V5.34C0,2.4,2.4,0,5.34,0h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM5.34,5c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34V5.34c0-.18-.16-.34-.34-.34H5.34Z" style="fill: #656565;"/>
                      <path d="M25.45,68.93H5.34c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM5.34,43.36c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34H5.34Z" style="fill: #656565;"/>
                      <path d="M25.45,107.29H5.34c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM5.34,81.72c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34H5.34Z" style="fill: #656565;"/>
                      <path d="M65.76,30.57h-20.11c-2.95,0-5.34-2.4-5.34-5.34V5.34c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM45.64,5c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34V5.34c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                      <path d="M65.76,68.93h-20.11c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM45.64,43.36c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                      <path d="M65.76,107.29h-20.11c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM45.64,81.72c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                      <path d="M106.06,30.57h-20.11c-2.95,0-5.34-2.4-5.34-5.34V5.34c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM85.95,5c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34V5.34c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                      <path d="M106.06,68.93h-20.11c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM85.95,43.36c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                      <path d="M106.06,107.29h-20.11c-2.95,0-5.34-2.4-5.34-5.34v-19.89c0-2.95,2.4-5.34,5.34-5.34h20.11c2.95,0,5.34,2.4,5.34,5.34v19.89c0,2.95-2.4,5.34-5.34,5.34ZM85.95,81.72c-.18,0-.34.16-.34.34v19.89c0,.18.16.34.34.34h20.11c.18,0,.34-.16.34-.34v-19.89c0-.18-.16-.34-.34-.34h-20.11Z" style="fill: #656565;"/>
                    </g>
                  </svg>
                </div>
              </article>
            </div>
          </div>
        </transition>

        <div class="slider-controls">
          <button type="button" @click.stop="previousContactPage" :disabled="contactPage === 0">‹</button>
          <div class="scrollbar" aria-hidden="true">
            <span :style="{ width: contactProgressWidth + '%', left: contactProgressLeft + '%' }"></span>
          </div>
          <button type="button" @click.stop="nextContactPage" :disabled="contactPage === contactTotalPages - 1">›</button>
        </div>
      </section>
    </main>

    <aside class="door-panel">
      <h2>Tür öffnet automatisch</h2>
      <div class="door-icon">
        <svg id="uuid-d5165aec-eb1b-49e4-84d4-116b85f52617" data-name="Ebene 3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 606.39 1041.73">
          <path d="M336.02,670.81c-8.28,0-15-6.72-15-15V90.87c0-8.28,6.72-15,15-15s15,6.72,15,15v564.94c0,8.28-6.72,15-15,15Z" style="fill: #fff;"/>
          <path d="M591.39,637.79h-72.69V91.87c0-6.38-4.04-12.07-10.07-14.17L287.7.83c-4.59-1.59-9.66-.87-13.62,1.94-3.96,2.81-6.31,7.37-6.31,12.23v61.87h-88.49c-8.28,0-15,6.72-15,15v545.92H15c-8.28,0-15,6.72-15,15s6.72,15,15,15h252.77v61.87c0,4.86,2.35,9.41,6.31,12.23,2.57,1.83,5.62,2.77,8.69,2.77,1.66,0,3.32-.27,4.93-.83l218.54-76.04h85.15c8.28,0,15-6.72,15-15s-6.72-15-15-15ZM194.27,637.79V106.87h73.49v530.92h-73.49ZM297.77,36.1l190.94,66.43v539.59l-190.94,66.43V36.1Z" style="fill: #fff;"/>
          <g style="opacity: .15;">
            <path d="M503.7,1041.73H179.27c-8.28,0-15-6.72-15-15v-373.94c0-8.28,6.72-15,15-15s15,6.72,15,15v358.94h294.43v-358.94c0-8.28,6.72-15,15-15s15,6.72,15,15v373.94c0,8.28-6.72,15-15,15Z" style="fill: #fff;"/>
          </g>
          <path d="M109.9,309.91H15c-8.28,0-15-6.72-15-15s6.72-15,15-15h79.9v-82.92H15c-8.28,0-15-6.72-15-15s6.72-15,15-15h94.9c8.28,0,15,6.72,15,15v112.92c0,8.28-6.72,15-15,15Z" style="fill: #fff;"/>
          <g>
            <path d="M321.04,933.34c-.69-4.66-1.31-7.2-1.14-13.3.81-27.82,8.1-32.57,5.42-53.86-2.08-16.46-13.47-27.38-27.62-26.35-16.24,1.19-31.11,23.55-23.47,60.94,1.87,9.14,4.7,17.83,8.17,26.62,1.25,3.16,2.09,6.47,2.46,9.85h0c.23,2.04.29,4.1.19,6.16-.17,3.23-.24,8.08.21,14.2,1.04,14.27,9.21,20.3,21.32,19.42,12.11-.89,18.92-8.02,18.27-22.31-.48-10.42-2.61-13.05-3.81-21.36Z" style="fill: #fff;"/>
            <path d="M385.27,840.6c-14.15-1.04-25.54,9.89-27.62,26.35-2.68,21.3,4.6,26.05,5.42,53.86.18,6.1-.44,8.63-1.14,13.3-1.21,8.32-3.34,10.95-3.81,21.36-.65,14.29,6.16,21.43,18.27,22.31,12.11.89,20.28-5.15,21.32-19.42.45-6.12.38-10.97.21-14.2-.11-2.05-.04-4.11.19-6.16h0c.38-3.38,1.22-6.69,2.46-9.85,3.46-8.79,6.3-17.48,8.17-26.62,7.64-37.39-7.23-59.76-23.47-60.94Z" style="fill: #fff;"/>
          </g>
        </svg>
      </div>
      <p>Bitte mittig vor der Tür bleiben<br>und Abstand zur Tür einhalten.</p>
    </aside>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";

const CONTACT_RESET_MS = 20000
// const CONTACT_RESET_MS = 2000000 // ToDo: only for DEV-Test
const HOURS_SWITCH_MS = 5000
const HOMEPAGE_CONTACT_URL = 'https://wesual-api.wesual.de/api/custom/vgnes/homepage-contacts' // über den Backend-Controller werden die Kontakt-Daten von 'https://www.bad-neustadt-vgem.de/ansprechpartner' gefetchet und returnet

export default {
  name: "VgBadNeustadtOutdoorMonitor",
  data () {
    return {
      currentDateTime: new Date(),
      isClosingMode: false,
      contactPage: 0,
      screenHeight: window.innerHeight,
      homepageContacts: [],
      clockInterval: null,
      hoursInterval: null,
      contactResetTimeout: null,
      contactSwipeStartX: null,
      contactSwipeStartY: null,
      resizeHandler: null
    }
  },
  computed: {
    ...mapGetters({
      getCurrentViewContent: 'getCurrentViewContent'
    }),
    currentTime () {
      return this.currentDateTime.toLocaleTimeString('de-DE', {hour: '2-digit', minute: '2-digit'})
    },
    currentDate () {
      return this.currentDateTime.toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: 'numeric'})
    },
    todayIndex () {
      return this.currentDateTime.getDay()
    },
    displayClosingMode () {
      return this.isClosingMode && this.hasClosingRows
    },
    hoursHeadline () {
      return this.displayClosingMode ? 'Unsere Schließzeiten' : 'Unsere Öffnungszeiten'
    },
    activeHoursRows () {
      return this.displayClosingMode ? this.closingRows : this.openingRows
    },
    openingRows () {
      return [
        {key: 'monday', day: 'Montag', value: '08:00 - 12:30', weekdayIndex: 1},
        {key: 'tuesday', day: 'Dienstag', value: '08:00 - 12:30, 14:00 - 16:30', weekdayIndex: 2},
        {key: 'wednesday', day: 'Mittwoch', value: '08:00 - 12:30', weekdayIndex: 3},
        {key: 'thursday', day: 'Donnerstag', value: '08:00 - 12:30, 14:00 - 17:30', weekdayIndex: 4},
        {key: 'friday', day: 'Freitag', value: '08:00 - 12:30', weekdayIndex: 5},
        {key: 'citizen-office', day: 'zusätzlich im Bürgerbüro'},
        {key: 'citizen-office-monday', day: 'Montag', value: '14:00 - 16:30', weekdayIndex: 1}
      ]
    },
    closingRows () {
      const content = this.getCurrentViewContent || {}
      const rows = this.normalizeRows(content.closing_rows || content.closingRows)

      if (rows.length > 0) {
        return rows
      }

      const htmlRows = this.parseHtmlRows(content.closing_times || content.closingTimes)

      if (htmlRows.length > 0) {
        return htmlRows
      }

      if (content.closing_times_text || content.closingTimesText) {
        return this.parseTextRows(content.closing_times_text || content.closingTimesText)
      }

      return []
    },
    hasClosingRows () {
      // Ohne gepflegte Backend-Schliesszeiten bleibt der Monitor dauerhaft bei den Oeffnungszeiten.
      return this.closingRows.length > 0
    },
    overviewContacts () {
      const content = this.getCurrentViewContent || {}
      const rows = this.normalizeContacts(content.overview_contacts || content.overviewContacts)

      if (rows.length > 0) {
        return rows
      }

      return [
        {title: 'Verwaltungsgemeinschaft Bad Neustadt a.d.Saale', phone: '09771 6160-0', email: 'mail@bad-neustadt-vgem.de'},
        {title: 'Bürgerbüro', phone: '09771 6160-70', email: 'buergerbuero@bad-neustadt-vgem.de'},
        {title: 'NES-Allianz', phone: '09771 6160-80', email: 'management@nes-allianz.de'},
        {title: 'Bauhofgemeinschaft BauGe Brend-Saale', phone: '09771 6160-90', email: 'mail@bauge-brend-saale.de'}
      ]
    },
    directoryContacts () {
      const content = this.getCurrentViewContent || {}
      const backendContacts = this.normalizeContacts(content.directory_contacts || content.directoryContacts || content.contacts)

      if (backendContacts.length > 0) {
        return backendContacts
      }

      return this.homepageContacts.length > 0 ? this.homepageContacts : this.fallbackDirectoryContacts
    },
    fallbackDirectoryContacts () {
      return [
        {name: 'Bürgerbüro', department: 'Bürgerbüro', description: 'Ausweis, Pass- und Meldewesen, Gewerbewesen, Fischerei, Fundsachen', phone: '09771 6160-70'},
        {name: 'Frau Kaiser', department: 'Geschäftsleitung', phone: '09771 6160-50', room: '215'},
        {name: 'Herr Koller', department: 'Geschäfts- und Abteilungsleitung', description: 'Stv. Geschäftsleitung, Leitung der Finanzabteilung', phone: '09771 6160-30', room: '201'},
        {name: 'Herr F.-J. Schmitt', department: 'Bauverwaltung', phone: '09771 6160-15', room: '108'},
        {name: 'EDV-Zentrale', department: 'Informations- und Kommunikationstechnik (EDV)', phone: '09771 6160-60'},
        {name: 'Frau Hehn', department: 'Kasse', phone: '09771 6160-38', room: '206'}
      ]
    },
    contactHeadline () {
      return this.contactPage === 0 ? 'Kontaktpersonen' : 'Ämter / Ansprechpartner'
    },
    contactSubline () {
      // return this.contactPage === 0 ? '(Bitte Pinpad nutzen)' : '(PIN und Telefonnummer)'
      return '(Bitte Pinpad nutzen)'
    },
    contactsPerPage () {
      // Lange Abteilungen/Beschreibungen koennen umbrechen; sechs Karten lassen genug vertikalen Raum pro Kontakt.
      return 6
    },
    contactTotalPages () {
      return Math.max(1, Math.ceil(this.directoryContacts.length / this.contactsPerPage) + 1)
    },
    visibleDirectoryContacts () {
      const start = (this.contactPage - 1) * this.contactsPerPage
      return this.directoryContacts.slice(start, start + this.contactsPerPage)
    },
    contactProgressWidth () {
      return 100 / this.contactTotalPages
    },
    contactProgressLeft () {
      return this.contactPage * this.contactProgressWidth
    }
  },
  methods: {
    normalizeRows (value) {
      if (!Array.isArray(value)) {
        return []
      }

      return value
          .map((row, index) => {
            if (typeof row === 'string') {
              const parts = row.split('|')
              return this.createHoursRow(parts[0], parts.slice(1).join('|'), index)
            }

            return this.createHoursRow(row.day || row.weekday || row.label, row.value || row.times || row.dates || row.text, index)
          })
          .filter(row => row.day && row.value)
    },
    parseTextRows (value) {
      if (typeof value !== 'string') {
        return []
      }

      return value
          .split('\n')
          .map((line, index) => {
            // Nur am ersten Trennzeichen schneiden, damit Uhrzeiten wie 08:00 erhalten bleiben.
            const parts = line.match(/^([^:|]+)[:|]\s*(.+)$/)
            return parts ? this.createHoursRow(parts[1], parts[2], index) : null
          })
          .filter(row => row && row.day && row.value)
    },
    parseHtmlRows (value) {
      if (typeof value !== 'string' || !value.trim() || typeof DOMParser === 'undefined') {
        return []
      }

      const document = new DOMParser().parseFromString(value, 'text/html')
      const tableRows = Array.from(document.querySelectorAll('tr'))
          .map((row, index) => {
            // CKEditor liefert die Schliesszeiten als Tabelle: erste Spalte Tag, zweite Spalte Datumswerte.
            const cells = Array.from(row.querySelectorAll('th, td'))
                .map(cell => this.normalizeText(cell.textContent))

            return cells.length >= 2 ? this.createHoursRow(cells[0], cells.slice(1).join(' '), index) : null
          })
          .filter(row => row && row.day && row.value)

      if (tableRows.length > 0) {
        return tableRows
      }

      const blockRows = Array.from(document.body.querySelectorAll('p, li'))
          .map((element, index) => {
            // Fallback fuer CKEditor-Inhalte ohne Tabelle, z.B. "Montag: 16.02.".
            const line = this.normalizeText(element.textContent)
            const parts = line.match(/^([^:|]+)[:|]\s*(.+)$/)
            return parts ? this.createHoursRow(parts[1], parts[2], index) : null
          })
          .filter(row => row && row.day && row.value)

      return blockRows.length > 0 ? blockRows : this.parseTextRows(document.body.textContent)
    },
    normalizeText (value) {
      return String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim()
    },
    createHoursRow (day, value, index) {
      const cleanedDay = this.normalizeText(day)

      return {
        key: `${cleanedDay}-${index}`,
        day: cleanedDay,
        value: this.normalizeText(value),
        weekdayIndex: this.weekdayIndexForLabel(cleanedDay)
      }
    },
    weekdayIndexForLabel (label) {
      const normalized = (label || '').toLowerCase()
      if (normalized.indexOf('montag') !== -1) return 1
      if (normalized.indexOf('dienstag') !== -1) return 2
      if (normalized.indexOf('mittwoch') !== -1) return 3
      if (normalized.indexOf('donnerstag') !== -1) return 4
      if (normalized.indexOf('freitag') !== -1) return 5
      if (normalized.indexOf('samstag') !== -1) return 6
      if (normalized.indexOf('sonntag') !== -1) return 0
      return null
    },
    normalizeContacts (value) {
      if (!Array.isArray(value)) {
        return []
      }

      return value
          .map(contact => ({
            title: contact.title || contact.name,
            name: contact.name || contact.title,
            department: contact.department || contact.area || contact.position,
            description: contact.description || contact.tasks || contact.text,
            phone: contact.phone || contact.telephone || contact.tel,
            email: contact.email || contact.mail,
            room: contact.room,
            pin: contact.pin || contact.pincode
          }))
          .filter(contact => (contact.title || contact.name) && contact.phone)
    },
    extractPhoneExtension (phone) {
      const match = String(phone || '').match(/-\s*(\d+)\s*$/)

      return match ? match[1] : ''
    },
    contactPin (contact) {
      // Die PIN entspricht der Durchwahl der Telefonnummer, z.B. 09771 6160-50 -> 50.
      return this.extractPhoneExtension(contact.phone) || String(contact.pin || 'PIN').replace(/^#/, '')
    },
    nextContactPage () {
      if (this.contactPage < this.contactTotalPages - 1) {
        this.contactPage++
      }
      this.registerInteraction()
    },
    previousContactPage () {
      if (this.contactPage > 0) {
        this.contactPage--
      }
      this.registerInteraction()
    },
    startContactSwipe (event) {
      if (!event.touches || event.touches.length !== 1) {
        return
      }

      this.contactSwipeStartX = event.touches[0].clientX
      this.contactSwipeStartY = event.touches[0].clientY
    },
    finishContactSwipe (event) {
      if (this.contactSwipeStartX === null || this.contactSwipeStartY === null || !event.changedTouches || event.changedTouches.length === 0) {
        this.resetContactSwipe()
        return
      }

      const deltaX = event.changedTouches[0].clientX - this.contactSwipeStartX
      const deltaY = event.changedTouches[0].clientY - this.contactSwipeStartY

      this.resetContactSwipe()

      // Nur eindeutige horizontale Swipes navigieren; vertikale Bewegungen/Taps bleiben normale Touch-Interaktionen.
      if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) {
        return
      }

      if (deltaX < 0) {
        this.nextContactPage()
      } else {
        this.previousContactPage()
      }
    },
    resetContactSwipe () {
      this.contactSwipeStartX = null
      this.contactSwipeStartY = null
    },
    registerInteraction () {
      clearTimeout(this.contactResetTimeout)
      this.contactResetTimeout = setTimeout(() => {
        this.contactPage = 0
      }, CONTACT_RESET_MS)
    },
    async loadHomepageContacts () {
      try {
        const response = await axios.get(HOMEPAGE_CONTACT_URL)
        const contacts = this.normalizeContacts(response.data)

        if (contacts.length > 0) {
          this.homepageContacts = contacts
        }
      } catch (error) {
        // Die Homepage-Kontakte kommen ueber das indisigno-Backend; bei Problemen bleibt der gepflegte Fallback sichtbar.
        console.warn('VG NES Ansprechpartner konnten nicht ueber das Backend geladen werden.', error)
      }
    }
  },
  mounted () {
    this.clockInterval = setInterval(() => {
      this.currentDateTime = new Date()
    }, 1000)
    this.hoursInterval = setInterval(() => {
      if (!this.hasClosingRows) {
        this.isClosingMode = false
        return
      }

      this.isClosingMode = !this.isClosingMode
    }, HOURS_SWITCH_MS)
    this.resizeHandler = () => {
      this.screenHeight = window.innerHeight
    }
    window.addEventListener('resize', this.resizeHandler)
    this.registerInteraction()
    this.loadHomepageContacts()
  },
  beforeDestroy () {
    clearInterval(this.clockInterval)
    clearInterval(this.hoursInterval)
    clearTimeout(this.contactResetTimeout)
    window.removeEventListener('resize', this.resizeHandler)
  }
}
</script>

<style scoped>
@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 300;
  src: url('/fonts/vg_nes/Poppins-Light.ttf') format("ttf")
}

@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  src: url('/fonts/vg_nes/Poppins-Regular.ttf') format("ttf")
}

@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  src: url('/fonts/vg_nes/Poppins-Medium.ttf') format("ttf")
}

@font-face {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  src: url('/fonts/vg_nes/Poppins-Bold.ttf') format("ttf")
}

.vgnes-outdoor-monitor {
  --vg-blue: #155c86;
  --vg-green: #008a18;
  --vg-text: #070707;
  --vg-muted: #6d6e71;
  --vg-panel: #f4f4f4;
  --vg-card: #ffffff;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  color: var(--vg-text);
  background: #fff;
  font-family: "Poppins",sans-serif;
}

.main-panel {
  width: 66.7vw;
  height: 100vh;
  display: grid;
  grid-template-rows: 40.5vh 59.5vh;
}

.status-section {
  display: grid;
  grid-template-columns: 36% 64%;
  /*padding: 3.7vw 4vw 2.2vw 4vw;*/
  padding: 3vw 4vw 2.2vw 4vw;
  min-height: 0;
  overflow: hidden;
}

.identity-column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 0;
}

.vgnes-logo {
  /*width: min(15vw, 32vh);*/
  width: min(10.5vw, 32vh);
}

.vgnes-logo svg {
  display: block;
  width: 100%;
  height: auto;
}

.vgnes-logo text {
  fill: #626366;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.4px;
}

.vgnes-logo .logo-bold {
  font-weight: 700;
}

.date-time {
  font-weight: 700;
  margin-bottom: 2vw;
}

.current-time {
  color: var(--vg-green);
  /*font-size: clamp(46px, 4.9vw, 118px);*/
  font-size: clamp(46px, 3.5vw, 118px);
  line-height: 0.95;
  letter-spacing: -0.08em;
}

.current-date {
  color: var(--vg-blue);
  /*font-size: clamp(36px, 3.4vw, 86px);*/
  font-size: clamp(36px, 3vw, 86px);
  line-height: 1.08;
  letter-spacing: -0.04em;
}

.hours-panel {
  position: relative;
  /*align-self: stretch;*/
  align-self: flex-start;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 0;
  /*overflow: hidden;*/
}

.clock-watermark {
  position: absolute;
  /*left: -6.2vw;*/
  /*top: -1.5vh;*/
  left: -3.8vw;
  top: -2.3vh;
  width: clamp(90px, 8vw, 185px);
  /*opacity: 0.08;*/
  opacity: 1;
}

.clock-watermark svg {
  width: 100%;
  fill: none;
  stroke: var(--vg-muted);
  stroke-width: 7;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.hours-panel h1 {
  color: var(--vg-blue);
  /*font-size: clamp(32px, 3vw, 76px);*/
  font-size: clamp(32px, 2.3vw, 76px);
  line-height: 1.05;
  margin: 0 0 clamp(10px, 1.45vh, 24px) 0;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.hoursHeadline {
  z-index: 10;
}
.hours-list {
  display: grid;
  /* Kompaktere Zeilen verhindern Layout-Sprünge, wenn die längeren Bürgerbüro-Öffnungszeiten eingeblendet werden. */
  gap: clamp(4px, 0.65vh, 12px);
}

.hours-row {
  position: relative;
  display: grid;
  grid-template-columns: minmax(12vw, 16vw) 1fr;
  align-items: center;
  min-height: clamp(24px, 2.55vh, 44px);
  border-radius: 999px;
  /*font-size: clamp(20px, 1.72vw, 42px);*/
  font-size: clamp(20px, 1.6vw, 42px);
  font-weight: 700;
  line-height: 1.05;
}

.hours-row.is-today {
  background: rgba(21, 92, 134, 0.08);
}

.today-marker {
  position: absolute;
  left: -4.5vw;
  top: 50%;
  transform: translateY(-50%);
  padding: 0.26vw 0.72vw;
  border-radius: 999px;
  background: var(--vg-blue);
  color: #fff;
  font-size: clamp(12px, 0.82vw, 20px);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.hours-day,
.hours-value {
  padding: 0.3vh 0.8vw;
}

.mode-indicator {
  display: flex;
  gap: 0.55vw;
  margin-top: clamp(8px, 1.2vh, 22px);
}

.mode-indicator span {
  width: 2.1vw;
  height: 0.34vh;
  border-radius: 999px;
  background: #d6d6d6;
}

.mode-indicator .active {
  background: var(--vg-blue);
}

.contacts-section {
  position: relative;
  background: var(--vg-panel);
  padding: 3.1vh 4vw 2.2vh 4vw;
  display: grid;
  grid-template-rows: auto 1fr auto;
  overflow: hidden;
}

.contacts-heading {
  display: flex;
  align-items: baseline;
  gap: 0.8vw;
  margin-bottom: 2.4vh;
}

.contacts-heading h2 {
  margin: 0;
  /*font-size: clamp(34px, 3.1vw, 74px);*/
  font-size: clamp(34px, 3.1vw, 62px);
  line-height: 1;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.contacts-heading span {
  color: var(--vg-muted);
  /*font-size: clamp(18px, 1.55vw, 38px);*/
  font-size: clamp(18px, 1.55vw, 32px);
}

.contacts-page {
  min-height: 0;
}

.overview-page {
  height: 100%;
  display: grid;
  grid-template-columns: 1fr minmax(210px, 18vw);
  gap: 1.2vw;
}

.overview-list {
  display: grid;
  /* Lange Mail-Adressen bekommen die volle Spaltenbreite, damit die vier Übersichtseinträge stabil untereinander passen. */
  grid-template-columns: 1fr;
  grid-template-rows: repeat(4, minmax(0, 1fr));
  gap: 1vh;
}

.overview-card,
.contact-card {
  background: var(--vg-card);
  /*box-shadow: inset -3.7vw 0 0 rgba(21, 92, 134, 0.03);*/
  position: relative;
}

.overview-card {
  min-height: 0;
  padding: 1vh 1.25vw;
}

.overview-card h3,
.contact-card h3 {
  color: var(--vg-blue);
  font-size: clamp(18px, 1.36vw, 32px);
  line-height: 1.05;
  margin: 0 0 0.65vh 0;
  font-weight: 700;
}

.overview-card p {
  margin: 0.25vh 0;
  color: #111;
  font-size: clamp(16px, 1.18vw, 30px);
  font-weight: 700;
  line-height: 1.15;
}

.overview-email {
  white-space: nowrap;
  display: flex; /* needed for contact-pin */
}

.next-hint {
  border: none;
  background: var(--vg-blue);
  color: #fff;
  border-radius: 0;
  padding: 1.4vw;
  font-family: inherit;
  font-size: clamp(20px, 1.45vw, 36px);
  font-weight: 700;
  line-height: 1.15;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.next-hint .arrow {
  font-size: clamp(54px, 5vw, 118px);
  font-weight:400;
  line-height: 0.6;
}

.directory-page {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.15vh 1.05vw;
}

.contact-card {
  position: relative;
  min-height: 0;
  /*padding: 1.1vh 1.25vw;*/
  padding: 0.5vh 1.25vw;
  display: grid;
  /*grid-template-columns: 1fr auto;*/ /* only needed if .contact-meta would be used */
  /*gap: 1vw;*/
  align-items: center;
}

.contact-card h3 span {
  color: var(--vg-muted);
  font-weight: 400;
}

.contact-card p {
  margin: 0.25vh 0 0 0;
  color: var(--vg-muted);
  font-size: clamp(14px, 1.04vw, 24px);
  line-height: 1.12;
}

.contact-card .contact-phone {
  display: flex;
  gap: 0.42vw;
  align-items: center;
  margin-top: 0.55vh;
  color: #111;
  font-size: clamp(16px, 1.14vw, 30px);
}

.contact-phone .phone-icon {
  color: #111;
  flex: 0 0 auto;
}

.contact-phone .phone-icon svg {
  display: block;
  width: clamp(20px, 1.24vw, 30px);
  height: clamp(20px, 1.24vw, 30px);
}

.contact-pin {
  color: var(--vg-green);
  margin-left:auto; /* to move element to most right position */
}

.contact-pin-bg {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 4vw;
  height: 6vh;
  overflow: hidden;
}

.contact-meta {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  color: var(--vg-green);
  font-size: clamp(15px, 1.02vw, 24px);
  line-height: 1.18;
}

.slider-controls {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 1vw;
  align-items: center;
  margin-top: 1.5vh;
}

.slider-controls button {
  width: clamp(36px, 3vw, 70px);
  height: clamp(32px, 2.4vw, 58px);
  border: none;
  background: var(--vg-blue);
  color: #fff;
  font-size: clamp(26px, 2.4vw, 58px);
  line-height: 0.7;
  cursor: pointer;
}

.slider-controls button:disabled {
  background: #cfcfcf;
  cursor: default;
}

.scrollbar {
  position: relative;
  height: 0.55vh;
  overflow: hidden;
  border-radius: 999px;
  background: #d9d9d9;
}

.scrollbar span {
  position: absolute;
  top: 0;
  bottom: 0;
  border-radius: 999px;
  background: var(--vg-blue);
  transition: left 0.25s ease, width 0.25s ease;
}

.door-panel {
  width: 33.3vw;
  height: 100vh;
  background: var(--vg-blue);
  color: #fff;
  display: grid;
  grid-template-rows: auto 1fr auto;
  padding: 7vh 3.2vw 7.4vh 3.2vw;
  box-sizing: border-box;
}

.door-panel h2 {
  margin: 0;
  text-align: center;
  /*font-size: clamp(36px, 3.2vw, 78px);*/
  font-size: clamp(36px, 3.2vw, 55px);
  line-height: 1.05;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.door-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.door-icon svg {
  width: min(25vw, 48vh);
  max-height: 58vh;
}

.door-stroke {
  fill: none;
  stroke: #fff;
  stroke-width: 20;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.door-shadow {
  fill: rgba(255, 255, 255, 0.16);
}

.door-panel p {
  margin: 0;
  text-align: center;
  /*font-size: clamp(24px, 2.05vw, 50px);*/
  font-size: clamp(24px, 2.05vw, 40px);
  line-height: 1.85;
  font-weight: 700;
}

.contact-slide-enter-active,
.contact-slide-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.contact-slide-enter,
.contact-slide-leave-to {
  opacity: 0;
  transform: translateX(1vw);
}

@media (max-aspect-ratio: 16/9) {
  .status-section {
    grid-template-columns: 34% 66%;
    padding-left: 3vw;
    padding-right: 3vw;
  }

  .contacts-section {
    padding-left: 3vw;
    padding-right: 3vw;
  }

  .hours-row {
    grid-template-columns: minmax(14vw, 17vw) 1fr;
  }
}
</style>
